export const REMEMBER_REHYDRATED = '@@REMEMBER_REHYDRATED';
export const REMEMBER_PERSISTED = '@@REMEMBER_PERSISTED';
